export const ORDER_TABLE_TABS = {
  all: 'all',
  authorised: 'authorised',
  approved: 'approved',
  captured: 'captured',
  refunded: 'refunded',
  canceled: 'canceled',
}

export const ORDER_STATUS = {
  canceled: 'canceled',
  fully_captured: 'fully_captured',
  fully_refunded: 'fully_refunded',
  partially_refunded: 'partially_refunded',
  authorised: 'authorised',
  approved: 'approved',
  partially_captured: 'partially_captured',
  updated: 'updated',
  declined: 'declined',
  expired: 'expired',
}

export default [
  {
    value: ORDER_STATUS.authorised,
    label: 'order_list_status_authorised',
    colorClass: 'blue',
    bulkLabel: 'bulk_authorise_title',
    bulkAction: 'bulk_authorise_cta',
    typeLabelFull: 'bulk_authorise_type_label',
    typeCtaFull: 'bulk_authorise_type_cta',
    typeLabelPartial: 'bulk_authorise_partial',
    confirmLabel: 'bulk_authorise_confirm',
    confirmCta: 'bulk_authorise_confirm_cta',
    hideBanner: true,
  },
  {
    value: ORDER_STATUS.approved,
    label: 'order_list_status_approved',
    colorClass: 'yellow',
  },
  {
    value: ORDER_STATUS.partially_captured,
    label: 'order_list_status_partially_captured',
    colorClass: 'yellow',
    bulkLabel: 'bulk_capture_title',
    bulkAction: 'bulk_capture_cta',
    typeLabelFull: 'bulk_capture_type_label',
    typeCtaFull: 'bulk_capture_type_cta',
    typeLabelPartial: 'bulk_capture_type_cta_partial',
    confirmLabel: 'bulk_capture_confirm',
    confirmCta: 'bulk_capture_confirm_cta',
  },
  {
    value: ORDER_STATUS.updated,
    label: 'order_list_status_updated',
    colorClass: 'blue',
  },
  {
    value: ORDER_STATUS.canceled,
    label: 'order_list_status_canceled',
    colorClass: 'red',
    bulkLabel: 'bulk_cancel_title',
    bulkAction: 'bulk_cancel_cta',
    typeLabelFull: 'bulk_cancel_type_label',
    typeCtaFull: 'bulk_cancel_type_cta',
    typeLabelPartial: 'bulk_cancel_partial',
    confirmLabel: 'bulk_capture_confirm',
    confirmCta: 'bulk_cancel_confirm_cta',
  },
  {
    value: ORDER_STATUS.fully_captured,
    label: 'order_list_status_fully_captured',
    colorClass: 'green',
    bulkLabel: 'bulk_capture_title',
    bulkAction: 'bulk_capture_cta',
    typeLabelFull: 'bulk_capture_type_label',
    typeCtaFull: 'bulk_capture_type_cta',
    typeLabelPartial: 'bulk_capture_type_cta_partial',
    confirmLabel: 'bulk_capture_confirm',
    confirmCta: 'bulk_capture_confirm_cta',
  },
  {
    value: ORDER_STATUS.fully_refunded,
    label: 'order_list_status_fully_refunded',
    colorClass: 'green',
    bulkLabel: 'bulk_refund_title',
    bulkAction: 'bulk_refund_cta',
    typeLabelFull: 'bulk_refund_type_label',
    typeCtaFull: 'bulk_order_refund_cta',
    typeLabelPartial: 'bulk_refund_partial',
    confirmLabel: 'bulk_capture_confirm',
    confirmCta: 'bulk_refund_confirm_cta',
  },
  {
    value: ORDER_STATUS.partially_refunded,
    label: 'order_list_status_partially_refunded',
    colorClass: 'yellow',
    bulkLabel: 'bulk_refund_title',
    bulkAction: 'bulk_refund_cta',
    typeLabelFull: 'bulk_refund_type_label',
    typeCtaFull: 'bulk_order_refund_cta',
    typeLabelPartial: 'bulk_refund_partial',
    confirmLabel: 'bulk_capture_confirm',
    confirmCta: 'bulk_capture_confirm_cta',
  },
]
